import { createSignal, Show } from "solid-js";
import { View, Text, hexColor } from "@lightningtv/solid";
import { fontFamily, isRTL, t } from "../../translations/configuration";

const SubmitButton = (props: {
  ref?: (el: any) => void;
  y?: number;
  submitting?: boolean;
  onUp?: () => void;
  onLeft?: () => void;
  onEnter?: () => void;
}) => {
  const [focused, setFocused] = createSignal(false);
  return (
    <View
      ref={props.ref}
      x={0} y={props.y ?? 0}
      width={900} height={72}
      borderRadius={14}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onUp={props.onUp}
      onLeft={props.onLeft}
      onEnter={props.onEnter}
    >
      <Show when={focused()}>
        <View x={-2} y={-2} width={904} height={76} borderRadius={16} color={hexColor("#1d4ed8")} zIndex={-1} />
      </Show>
      <View x={0} y={0} width={900} height={72} borderRadius={14} color={hexColor(props.submitting ? "#374151" : focused() ? "#18212e" : "#0d1117")}>
        <Text x={340} y={22} style={{ fontSize: 26, color: hexColor("#ffffff"), fontWeight: isRTL() ? "normal" : "bold", fontFamily: fontFamily() }}>
          {props.submitting ? t("adding") : t("addPlaylist")}
        </Text>
      </View>
    </View>
  );
};

export default SubmitButton;
